document.addEventListener('DOMContentLoaded', function () {
  var accordions = document.querySelectorAll('.returns-exchanges__accordion');

  accordions.forEach(function (accordion) {
    var triggers = accordion.querySelectorAll('.returns-exchanges__trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        // close any other open item in this accordion (single-open behavior)
        triggers.forEach(function (otherTrigger) {
          if (otherTrigger !== trigger && otherTrigger.getAttribute('aria-expanded') === 'true') {
            var otherPanel = document.getElementById(otherTrigger.getAttribute('aria-controls'));
            closePanel(otherTrigger, otherPanel);
          }
        });

        if (isOpen) {
          closePanel(trigger, panel);
        } else {
          openPanel(trigger, panel);
        }
      });
    });
  });

  function openPanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'true');
    var innerHeight = panel.scrollHeight;
    panel.style.height = innerHeight + 'px';

    panel.addEventListener('transitionend', function handler() {
      panel.style.height = 'auto';
      panel.removeEventListener('transitionend', handler);
    });
  }

  function closePanel(trigger, panel) {
    trigger.setAttribute('aria-expanded', 'false');
    // set explicit height first so the transition to 0 animates smoothly
    panel.style.height = panel.scrollHeight + 'px';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });
    });
  }
});
